var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isPC ? 'app-pc' : 'app-h5'],attrs:{"id":"app"}},[_c('DragTUICallKit'),_c('router-view'),_c('Upgrade')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }